import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoRoutingModule } from './video-routing.module';
import { SharedModule } from '../shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgsRevealModule } from 'ngx-scrollreveal';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

import { VideoGridComponent } from './video-grid/video-grid.component';
import { VideoComponent } from './video/video.component';
import { DlaComponent } from './dla/dla.component';
import { TntComponent } from './tnt/tnt.component';
import { AttComponent } from './att/att.component';
import { EteComponent } from './ete/ete.component';
import { Kfp3Component } from './kfp3/kfp3.component';
import { StxComponent } from './stx/stx.component';
import { TbsComponent } from './tbs/tbs.component';
import { ToyotaComponent } from './toyota/toyota.component';
import { FjComponent } from './fj/fj.component';
import { OpiComponent } from './opi/opi.component';
import { DinelaComponent } from './dinela/dinela.component';
import { MintComponent } from './mint/mint.component';
import { ExperianComponent } from './experian/experian.component';
import { LivelyComponent } from './lively/lively.component';
import { GotoComponent } from './goto/goto.component';
import { BluelandComponent } from './blueland/blueland.component';
import { JitbComponent } from './jitb/jitb.component';
import { HellosignComponent } from './hellosign/hellosign.component';
import { SnapComponent } from './snap/snap.component';
import { LastpassComponent } from './lastpass/lastpass.component';
import { TurbotaxComponent } from './turbotax/turbotax.component';





@NgModule({
  declarations: [
    VideoGridComponent,
    VideoComponent,
    DlaComponent,
    TntComponent,
    AttComponent,
    EteComponent,
    Kfp3Component,
    StxComponent,
    TbsComponent,
    ToyotaComponent,
    FjComponent,
    OpiComponent,
    DinelaComponent,
    MintComponent,
    ExperianComponent,
    LivelyComponent,
    GotoComponent,
    BluelandComponent,
    JitbComponent,
    HellosignComponent,
    SnapComponent,
    LastpassComponent,
    TurbotaxComponent
  ],
  imports: [
    CommonModule,
    VideoRoutingModule,
    BrowserAnimationsModule,
    NgsRevealModule,
    ScrollToModule.forRoot(),
    SharedModule
  ]
})

export class VideoModule { }
